import { type Nullable } from '../../types/common'
import NotificationComponent from '../notification/notification'
import ProductBreadcrumbs from '../product-breadcrumbs/product-breadcrumbs'
import Notification from './notification'

class BodyElement {
  notification: Nullable<Notification>
  overlayCalls: any[]
  isScrolling: boolean
  overlayId: string
  timeoutScrollId: number

  constructor() {
    const notificationElement = document.getElementById(
      'GlobalNotification',
    ) as NotificationComponent

    if (notificationElement) {
      this.notification = new Notification(notificationElement)
    }

    this.isScrolling = false

    this.overlayId = 'BodyOverlay'

    window.addEventListener('wheel', this.handleWindowScroll)

    this.overlayCalls = []

    if (window.location.pathname.includes('products')) {
      customElements.define('product-breadcrumbs', ProductBreadcrumbs)

      this.setBreadcrumbs()
    }

    const isCaptchaPage = window.location.pathname.includes('challenge')
    const isAccountPage = window.location.pathname.includes('account')

    if (!isCaptchaPage && !isAccountPage) {
      if (localStorage.getItem('isRegistered')) {
        this.showRegistrationMessage()
      }
    }
  }

  handleWindowScroll = (): void => {
    if (this.timeoutScrollId) {
      clearTimeout(this.timeoutScrollId)

      this.isScrolling = true
    }

    this.timeoutScrollId = setTimeout(() => {
      this.isScrolling = false
    }, 300)
  }

  showOverlay(key: string, styles): void {
    const defaultStyles = {
      zIndex: 3,
      backgroundColor: 'var(--gsc-black-color-50)',
    }
    const bodyOverlay = document.getElementById(this.overlayId)

    if (!bodyOverlay) {
      return
    }

    this.overlayCalls = [...this.overlayCalls, { key, styles }]

    this.setBodyOverlayStyles({ ...defaultStyles, ...styles })

    bodyOverlay.setAttribute('visible', '')

    this.setScrollLock()
  }

  hideOverlay(key: string): void {
    const bodyOverlay = document.getElementById(this.overlayId)

    if (!bodyOverlay) {
      return
    }

    const isVisible = bodyOverlay.hasAttribute('visible')

    if (!isVisible) {
      return
    }

    this.overlayCalls = this.overlayCalls.filter(
      overlayCall => overlayCall.key !== key,
    )

    const lastCall = this.overlayCalls[this.overlayCalls.length - 1]

    if (lastCall) {
      this.setBodyOverlayStyles(lastCall.styles)
    } else {
      bodyOverlay.removeAttribute('visible')
      bodyOverlay.setAttribute('style', '')
      this.unsetScrollLock()
    }
  }

  setScrollLock(): void {
    document.body.style.top = `-${
      window.scrollY || Math.abs(parseInt(document.body.style.top || '0'))
    }px`
    document.body.setAttribute('scroll-y-off', '')
  }

  unsetScrollLock(): void {
    const scrollY = document.body.style.top

    document.body.removeAttribute('scroll-y-off')
    document.body.style.top = ''

    window.scrollTo(0, parseInt(scrollY || '0') * -1)
  }

  setBodyOverlayStyles(styles): void {
    const bodyOverlay = document.getElementById(this.overlayId)

    if (!bodyOverlay) {
      return
    }

    if (styles) {
      const styleKeyList = Object.keys(styles)

      styleKeyList.forEach(key => {
        bodyOverlay.style[key] = styles[key]
      })
    }
  }

  setBreadcrumbs = (): void => {
    const breadcrumbsElements = document.querySelectorAll('product-breadcrumbs')

    if (breadcrumbsElements.length) {
      const prevCollectionPage = localStorage.getItem('prevCollectionPage')

      breadcrumbsElements.forEach(el => {
        el.setCollectionPage(prevCollectionPage)
      })

      localStorage.removeItem('prevCollectionPage')
    }
  }

  showRegistrationMessage = (): void => {
    const message = window.auroraThemeLocales.registrationMessage
    const visibilityDuration = 10000

    customElements.whenDefined('notification-component').then(() => {
      this.notification.show(message, 'success', visibilityDuration)

      localStorage.removeItem('isRegistered')
    })
  }

  get isFixed(): boolean {
    return document.body.hasAttribute('scroll-y-off')
  }
}

export const bodyElement = new BodyElement()
